export default {
  type: 'line',
  data: {
    labels: null,
    datasets: [
      {
        data: [],
        borderWidth: 2,
        backgroundColor: '#1BA7C9',
        borderColor: '#1BA7C9',
        fill: false,
        showLines: true,
      },
    ],
  },
  options: {
    animation: false,
    tooltips: {
      callbacks: null,
    },
    legend: {
      position: 'bottom',
      display: true,
    },
    title: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          type: 'time',
          time: {
            unit: null,
            displayFormats: {
              day: 'MM/DD',
              month: 'YYYY/MM',
            },
          },
          ticks: {
            source: null,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            suggestedMax: 10,
          },
        },
      ],
    },
  },
}
